import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BotAvatar from '../assets/images/bot-avatar.png';

class BrokenImage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            brokenImage: false,
        };
        this.onError = this.onError.bind(this);
    }

    onError() {
        this.setState({
            brokenImage: true,
        });
    }

    render() {
        const {brokenImage} = this.state;
        const {
            src, alt, text, imageStyles, textStyles, ...rest
        } = this.props;

        if (!brokenImage) {
            return <img src={src} alt={alt} {...rest} onError={this.onError} style={imageStyles}/>;
        }

        return (
            <img src={BotAvatar} alt={alt} {...rest} onError={this.onError} style={imageStyles}/>
        );
    }
}

BrokenImage.propTypes = {
    src: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    rest: PropTypes.object,
    alt: PropTypes.string.isRequired,
    imageStyles: PropTypes.object,
    textStyles: PropTypes.object,
};

BrokenImage.defaultProps = {
    rest: {},
    imageStyles: {minWidth: '22px'},
    textStyles: {},
};

export default BrokenImage;



// WEBPACK FOOTER //
// ./src/components/BrokenImage.jsx